<template>
  <div>
   

    <DataTable
      :url="api.ACTIONS.COMPANY_REQUESTS"
      :titles="titles"
      :fields-hidden-main="['deleted_at', 'updated_at','info']"
      :fields-hidden-add="[]"
      :input-types-add="{}"
      :formatter="formatters"
      :title='$t("acquisitionPage.pageTitleCompanyRequests")'
      :enableEdit="false"
      :actions-extra-main="actionsExtraMain"
      :add-rules="rules"
      :enableAdd="false"
    />
  </div>
</template>
<style>
.cbtn {
  float: inline-end;
  z-index: 1;
  margin-top: 20px;
  margin-inline-end: 20px;
  padding: 0px 45px;
}
</style>
<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";

export default {
  name: "CompanyRequests",
  title() {
    return this.$t("acquisitionPage.pageTitleCompanyRequests");
  },
  components: { DataTable },
  data() {
    return {
      formatters: {
        created_at(value) {
          return formatCompanyTime(value, " DD MMM YYYY");
        },
        approved_at(value) {
          return value ? formatCompanyTime(value, " DD MMM YYYY"): '';
        },
      },
    };
  },
  computed: {
    rules() {
      return {
        
      };
    },
   

    titles() {
      return {
        id: "#",
        company_name: this.$t("acquisitionPage.colCompanyName"),
        contact_name: this.$t("acquisitionPage.colContactName"),
        email: this.$t("acquisitionPage.colEmail"),
        phone_number: this.$t("acquisitionPage.colPhone"),
        legal_form: this.$t("acquisitionPage.colLegalForm"),
        street: this.$t("acquisitionPage.colStreet"),
        no: this.$t("acquisitionPage.colNo"),
        postal_code: this.$t("acquisitionPage.colPostalCode"),
        city: this.$t("acquisitionPage.colCity"),
        rci_no: this.$t("acquisitionPage.colRciNo"),
        created_at: this.$t("acquisitionPage.colCreationDate"),
        approved_at: this.$t("acquisitionPage.colApprovalDate")
      };
    },
    actionsExtraMain() {
      return {
        prices: {
          title: this.$t("acquisitionPage.actionCompanyRequest"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "CompanyRequest",
              params: { id: item.id },
            }),
        },
      };
    },
  },
};
</script>
